import * as React from 'react';

interface TransitTooltipProps {
	isTransitTariff: boolean;
}

export const TransitTooltipContext = React.createContext<TransitTooltipProps>({ isTransitTariff: false });
